import {config} from "../config";
import {ITelemetry} from "./ITelemetry";
import {LogSink} from "./logSink";
import * as analyticsSink from "./analyticsSink";

var extend = require("extend");


export var Telemetry = function (logSink, analyticsSink, context) {
    var This = this;
    This._init(logSink, analyticsSink, context);
};

Telemetry.prototype.clone = function () {
    var This = this;
    return new Telemetry(This._logSink, This._analyticsSink, extend(true, {}, This._context));
};

Telemetry.prototype.context = function () {
    var This = this;
    return This._context;
};

Telemetry.prototype._log = function (level, d) {
    var This = this;

    //Mutate objects so they can undergo JSON.stringify();
    if (typeof d === "undefined") {
        d = "<undefined>";
    }
    else if (d && d instanceof Error) {
        d = {
            name: d.name,
            msg: d.message,
            stack: d.stack
        };
    }

    //Normalize String -> string, Number -> number etc
    var logObj = JSON.parse(JSON.stringify(d));

    var logObjType = <string>typeof logObj;
    if (logObjType === "null") {
        logObj = {
            msg: "<null>"
        };
    }
    else if (
        logObjType === "string" || logObjType === "number" || logObjType == "boolean" ||
        //Assuming logObjType === "object" below since everything else should be filtered above
        logObj instanceof Array
    ) {

        logObj = {
            msg: logObj
        };
    }

    This._logSink.push(extend(true, {level: level}, This._context, logObj));
};

Telemetry.prototype._analytics = function(d){
    var This = this;
    return This._analyticsSink.push(d);
};

Telemetry.prototype.getLogSink = function () {
    return this._logSink;
};

Telemetry.prototype.getAnalyticsSink = function () {
    return this._analyticsSink;
};

/**
 * Use this instead of console.trace.  This will give you stack trace in addition to standard log.
 * This will not be recorded on the server.
 * @param any
 */
Telemetry.prototype.trace = function (any) {
    this._log(10, any);
};

/**
 * Use this instead of console.log for debugging.  This will not get recorded on the server.
 * @param any
 */
Telemetry.prototype.debug = function (any) {
    this._log(20, any);
};

/**
 * Use this to log info which will help you debug during production troubleshooting.
 * @param any
 */
Telemetry.prototype.info = function (any) {
    this._log(30, any);
};

/**
 * Use this find scenarios where there is a non fatal error.  This will get recorded on the server.
 * @param any
 */
Telemetry.prototype.warn = function (any) {
    this._log(40, any);
};

/**
 * Use this to log fatal errors.  This will get recorded on the server.
 * @param any
 */
Telemetry.prototype.error = function (any) {
    this._log(50, any);
};

Telemetry.prototype._init = function (logSink, analyticsSink, context) {
    var This = this;
    This._logSink = logSink || [];
    This._analyticsSink = analyticsSink || [];
    This._context = context || {};
};

Telemetry.prototype.identify = function (userId, profile) {
    var This = this;
    var identity = {type: "identify", userId: userId, profile: profile};
    This.info(identity);
    return This._analytics(identity);
};

Telemetry.prototype.setEvent = function (eventId) {
    var This = this;
    var action = {type: "setEvent", eventId: eventId};
    This._context.eventId = eventId;
    This.info(action);
    return This._analytics(action);
};

Telemetry.prototype.clearEvent = function () {
    var This = this;
    var action = {type: "clearEvent"};
    delete This._context.eventId;
    This.info(action);
    return This._analytics(action);
};

/**
 * Logs a user event with telemetry
 * @param category -- e.g "Admin" "Joy" or "Wedding"
 * @param action -- e.g. "ColorSet"
 * @param label -- e.g. "#121212"
 * @param route -- e.g. "/joe-and-jane"
 * @param referrer -- e.g. "/"
 * @param extraInfo -- anything
 */
Telemetry.prototype.event = function (category, action, route, referrer, extraInfo) {
    var This = this;
    var eventInfo;

    // back compat event()
    if (typeof category === "string") {
        eventInfo = extend(true, {}, This._context, {
            type: "event",
            category: category,
            action: action,
            route: route,
            referrer: referrer,
            extraInfo: extraInfo
        });
        eventInfo.label = JSON.stringify(eventInfo);
    }
    else {
        eventInfo = extend(true, {}, This._context, category);
        eventInfo.type = "event";
    }

        This.info(eventInfo);
        return This._analytics(eventInfo);
};

/**
 * Logs a page view with telemetry
 * @param category -- e.g "Admin" "Joy" or "Wedding"
 * @param name -- e.g. "Joe & Jane"
 * @param route -- e.g. "/joe-and-jane"
 * @param referrer -- e.g. "/"
 * @param extraInfo -- anything
 */
Telemetry.prototype.page = function (category, name, route, referrer, extraInfo) {
    var This = this;
    var pageInfo;

    // back compat page()
    if (typeof category === "string") {
        pageInfo = extend(true, {}, This._context, {
            type: "page",
            category: category,
            name: name,
            route: route,
            referrer: referrer,
            extraInfo: extraInfo
        });
    }
    else {
        pageInfo = extend(true, {}, This._context, category);
        pageInfo.type = "page";
    }

    This.info(pageInfo);
    return This._analytics(pageInfo);
};


/**
 * Logs a user event with telemetry
 * @param linkElementId
 * @param category -- e.g "Admin" "Joy" or "Wedding"
 * @param action -- e.g. "ColorSet"
 * @param label -- e.g. "#121212"
 * @param route -- e.g. "/joe-and-jane"
 * @param referrer -- e.g. "/"
 * @param extraInfo -- anything
 */
Telemetry.prototype.link = function (linkElementId, category, action, route, referrer, extraInfo) {
    var This = this;
    var linkInfo;

    // back compat link()
    if (typeof category === "string") {
        linkInfo = extend(true, {}, This._context, {
            type: "link",
            linkElementId: linkElementId,
            category: category,
            action: action,
            route: route,
            referrer: referrer,
            extraInfo: extraInfo
        });
        linkInfo.label = JSON.stringify(linkInfo);
    }
    else {
        linkInfo = extend(true, {}, This._context, linkElementId);
        linkInfo.type = "link";
    }

    This.info(linkInfo);
    return This._analytics(linkInfo);
};

/**
 * Makes sure that all telemetry has been recorded. Best called before crash or when script unload is imminent.
 */
Telemetry.prototype.flush = function (callback) {
    var This = this;


    var incr = function () {};
    var decr = incr;
    if (callback) {
        var count = 0;
        incr = function () {
            count++;
        };

        decr = function () {
            count--;
            if (count === 0) {
                if (callback) {
                    callback();
                    callback = null;
                }
            }
        };
    }

    var tryAnalyticsFlush = function () {
        if (This._analyticsSink.flush) {
            console.log("analytics flush started");
            incr();
            This._analyticsSink.flush(function () {
                console.log("analytics flush complete");
                decr();
            });
        }
    };

    var tryLogSinkFlush = function () {
        if (This._logSink.flush) {
            incr();
            console.log("log flush started");
            This._logSink.flush(extend(true, {level: 50}, This._context, {msg: "flush"}), function () {
                console.log("log flush complete");
                decr();
            });
        }
    };

    incr();
    tryAnalyticsFlush();
    tryLogSinkFlush();
    decr();

};

export const telemetry: ITelemetry = new Telemetry(new LogSink(config), new analyticsSink.AnalyticsSink(config), null);
